// utils
import anime from 'animejs'
import {
  createAnimation
} from '@/assets/js/utils/createAnimation'
import {
  characterWalk
} from '@/assets/js/utils/characterWalk'
import {
  createRotateAnimation
} from '@/assets/js/utils/createRotateAnimation'
import {
  createWalkAnimation
} from '@/assets/js/utils/createWalkAnimation'

const dylanAnimations = () => {
  return {
    raiseRightArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#dylan_right_arm",
            rotate: "15deg",
            duration: 350,
            easing: "linear",
            begin: options.begin,
          })

        if (options.quarter) {
          tl
            .add({
              targets: "#dylan_right_arm_hand",
              rotate: "40deg",
              duration: 350,
              easing: "linear",
              complete: options.complete
            })
        } else if (options.half) {
          tl
            .add({
              targets: "#dylan_right_arm_hand",
              rotate: "65deg",
              duration: 350,
              easing: "linear",
              complete: options.complete
            })
        } else {
          tl
            .add({
              targets: "#dylan_right_arm_hand",
              rotate: "90deg",
              duration: 350,
              easing: "linear",
              complete: options.complete
            })
        }

      }, options, this)()
    },
    raiseLeftArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#dylan_left_arm",
            rotate: "-15deg",
            duration: 350,
            easing: "linear",
            begin: options.begin,
          })
          .add({
            targets: "#dylan_left_arm_hand",
            rotate: "75deg",
            duration: 350,
            easing: "linear",
            complete: options.complete
          })
      }, options, this)()
    },
    handShake(options) {
      return createAnimation((tl, options) => {
        // todo;
        tl
          .add({
            targets: "#dylan_right_arm",
            rotate: "30deg",
            duration: 350,
            easing: "linear",
            begin: options.begin,
          })
          .add({
            targets: "#dylan_right_arm_hand",
            rotate: "47deg",
            duration: 350,
            easing: "linear",
          })
          .add({
            targets: "#dylan_right_arm_hand",
            rotate: "36deg",
            duration: 350,
            easing: "linear",
          })
          .add({
            targets: "#dylan_right_arm_hand",
            rotate: "47deg",
            duration: 350,
            easing: "linear",
            complete: options.complete,
          })
      }, options, this)()
    },
    lowerLeftArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#dylan_left_arm_hand",
            rotate: "0deg",
            duration: 350,
            easing: "linear",
            begin: options.begin,
          })
          .add({
            targets: "#dylan_left_arm",
            rotate: "0deg",
            duration: 350,
            easing: "linear",
            complete: options.complete
          })
      }, options, this)()
    },
    lowerRightArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#dylan_right_arm_hand",
            rotate: "0deg",
            duration: 350,
            easing: "linear",
            begin: options.begin,
          })
          .add({
            targets: "#dylan_right_arm",
            rotate: "0deg",
            duration: 350,
            easing: "linear",
            complete: options.complete
          })
      }, options, this)()
    },
    walk(options) {
      return createAnimation(createWalkAnimation('#dylan'), options, this)()
    },
    rotate(options) {
      return createAnimation(createRotateAnimation('#dylan_outer'), options, this)()
    },
  }
}

export {
  dylanAnimations
}



// WEBPACK FOOTER //
// ./src/components/module_6/js/dylanAnimations.js